import { z } from 'zod/v4';

import axios from '../localAxios';
import {
  GenerateQuestionsResponse,
  generateQuestionsResponseSchema,
} from './generateQuestionByAreasOfImprovement';
import { generateQuestionsByStudentsURL } from './urls/generateQuestionsByStudentsURL';

export interface GenerateQuestionByStudentsParams {
  activityInstanceId: number;
  studentIds: string[];
  questionCount: number;
  generateExplanations: boolean;
}

export async function generateQuestionByStudents({
  activityInstanceId,
  studentIds,
  questionCount,
  generateExplanations,
}: GenerateQuestionByStudentsParams): Promise<GenerateQuestionsResponse> {
  const url = generateQuestionsByStudentsURL(activityInstanceId);

  const response = await axios.post(url.href, {
    studentIds,
    questionCount,
    generateExplanations,
  });

  const { data, error } = generateQuestionsResponseSchema.safeParse(
    response.data
  );

  if (error) {
    throw new Error(z.prettifyError(error));
  }
  return data;
}
